import React from 'react';
import ImgIconComp from '../../imgcomp';
import {KeyDownEvent} from "../../../utils/eventKey"

const ModalHeader = ({title, closePopup, button = null, ally = null, id = ''}) => (
    <div className="wbmodal-header">
        <h1 className="wbmodal-htitle left" id={id}>
          {title}
        </h1>
        {
          button &&
          <div className="right clickable cta" onClick={button.onClick}>
            {
              button.iconClass &&
              <span className={button.iconClass}></span>
            }
            {button.label}
          </div>
        }
        <div className={`wbmodal-hcancel clickable commonModalCancel ${!button ? "right" : ""}`} onClick={() => closePopup()}
          onKeyDown={(e) => KeyDownEvent(e, () => closePopup())}
        >
          {/* <ImgIconComp id="close" width="13" height="13" /> */}
          <i className="icon icon-outline-close-24px"
            tabIndex={0}
            aria-label="close"
            role="button">
          </i>
        </div>
        <div className="clear" />
    </div>
  );

export default ModalHeader;